const env = 'BETA'
const ENV_LABEL = 'BETA'
const APP_NAME = 'Kristo Network'
const IS_CORDOVA = false
const API_ROOT_URL = 'https://beta.kristo.network/api/v1'
const ROOT_URL = 'https://beta.kristo.network'
const STORAGE_URL = 'https://beta.kristo.network/storage'
const STORAGE_GEO_VN_DATA_URL =
  'https://beta.kristo.network/storage/geodata/json/vietnamLow.json'
const STORAGE_GEO_US_DATA_URL =
  'https://beta.kristo.network/storage/geodata/json/usaLow.json'
const SOCKET_URL = 'https://socket.beta.kristo.network'
const FB_ID = '701178521927538'
const GG_ID = '268085637592-dljop20g3t6rfpoh09jkof8o8or0qg7g.apps.googleusercontent.com'
const ZALO_ID = '2170735338616595123'
const ANDROID_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=kristo.app'
const APPLE_ITUNES_LINK =
  'https://itunes.apple.com/us/app/kristo-app/id1234567890'
const GOOGLE_API_KEY = 'AIzaSyD47O3ZYO74MwAhsH_BCF3A6WEHVDAkg_w'
const FIREBASE_MESSAGING_SENDER_ID = '{FIREBASE_MESSAGING_SENDER_ID}}'
const CONTACT_EMAIL = 'contact@kristo.network'
const CONTACT_PHONE = '090 9 31 35 18'
const GOOGLE_DATA_AD_CLIENT = '{GOOGLE_DATA_AD_CLIENT}'
const GOOGLE_DATA_AD_ENABLED = false
const GOOGLE_DATA_AD_SLOT_RECOMMENDED_UNIT = '{GOOGLE_DATA_AD_SLOT_RECOMMENDED_UNIT}'
const GOOGLE_DATA_AD_SLOT_IN_FEED_UNIT = '{GOOGLE_DATA_AD_SLOT_IN_FEED_UNIT}'
const GOOGLE_DATA_AD_SLOT_IN_ARTICLE_UNIT = '{GOOGLE_DATA_AD_SLOT_IN_ARTICLE_UNIT}'
const APP_COPYRIGHT = 'Copyright ©2026 Kristo Network'
const APP_CHANNEL_VI = 'blog-kristo-network-vietnam'

export {
  env,
  ENV_LABEL,
  APP_NAME,
  IS_CORDOVA,
  ROOT_URL,
  API_ROOT_URL,
  STORAGE_URL,
  SOCKET_URL,
  STORAGE_GEO_VN_DATA_URL,
  STORAGE_GEO_US_DATA_URL,
  FB_ID,
  GG_ID,
  ZALO_ID,
  ANDROID_PLAY_LINK,
  APPLE_ITUNES_LINK,
  GOOGLE_API_KEY,
  FIREBASE_MESSAGING_SENDER_ID,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  GOOGLE_DATA_AD_CLIENT,
  GOOGLE_DATA_AD_ENABLED,
  GOOGLE_DATA_AD_SLOT_RECOMMENDED_UNIT,
  GOOGLE_DATA_AD_SLOT_IN_FEED_UNIT,
  GOOGLE_DATA_AD_SLOT_IN_ARTICLE_UNIT,
  APP_COPYRIGHT,
  APP_CHANNEL_VI,
}
